import { getConfig } from 'EnvConfig'

import { primePublicPortalConfig } from './bootstrap/fetch-public-portal-config'

const preconnect = (href: string) => {
  if (document.head.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
    return
  }

  const link = document.createElement('link')

  link.rel = 'preconnect'
  link.href = href
  document.head.appendChild(link)
}

const bootstrap = async () => {
  if (window.bootstrapped) return

  const { CUSTOMER_PORTAL_API_URL, DESIGN_BUILDER_API_URL } = getConfig()

  preconnect(new URL(CUSTOMER_PORTAL_API_URL).origin)
  preconnect(new URL(DESIGN_BUILDER_API_URL).origin)

  const portalConfigPromise = primePublicPortalConfig()
  const appModulePromise = import('index')

  const portalConfig = await portalConfigPromise
  const isEmbedded = window.parent !== window

  if (isEmbedded) {
    const { getDummyApi, isInDummyMode } = await import('dummy/static')

    if (isInDummyMode(portalConfig as never)) {
      const Dummy = await getDummyApi()

      await Dummy?.getConfig(portalConfig as never)
    }
  }

  window.bootstrapped = true

  if (portalConfig.prevent_search_engine_indexing) {
    let metaRobots = document.head.querySelector('meta[name="robots"]')

    if (!metaRobots) {
      metaRobots = document.createElement('meta')
      metaRobots.setAttribute('name', 'robots')
      document.head.appendChild(metaRobots)
    }

    metaRobots.setAttribute('content', 'noindex, nofollow')
  }

  const { main } = await appModulePromise

  await main()
}

export default bootstrap
